<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-card rounded="xl" outlined>
          <v-card-title>
            <h6 class="text-sm-h4 text-h6 mx-auto">Подача заявлений на проживание</h6>
          </v-card-title>
        </v-card>
        <v-row class="mt-2">
            <v-col
              class="d-flex"
              cols="12" md="4"
            >
              <CardPersPerf/>
            </v-col>
            <v-col cols="12" md="8" class="d-flex flex-column">
              <v-row>
                <v-col cols="12">
                  <CurrPlaceHostel/>
                </v-col>
              </v-row>
              <v-row class="fill-height">
                <v-col cols="12" md="6" class="d-flex">
                  <v-row class="full-height">
                    <v-col cols="12" class="d-flex">
                      <CardStatusesAllowance/>
                    </v-col>
                    <v-col cols="12" class="d-flex">
                      <CardLastStmHostel/>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class="d-flex">
                  <CardHostelPlace/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
      </v-container>
    </v-main>
    <!--        <v-divider class="mt-5 pb-5"></v-divider>-->
    <!--        <p class="text-center text-h6">Список заявлений на места в общежитиях в рамках факультета</p>-->
    <!--        <div class="px-5 pb-5">-->
    <!--            <CardListStatement/>-->
    <!--        </div>-->
  </v-app>
</template>

<script>
    import CardPersPerf from "../Cards/Pichers/CardPersPerf.vue";
    import CardHostelPlace from "../Cards/Pichers/CardHostelPlace.vue";
    import CurrPlaceHostel from "../Cards/Pichers/CurrPlaceHostel.vue";
    import CardStatusesAllowance from "../Cards/Pichers/CardStatusesAllowance.vue";
    import CardLastStmHostel from "../Cards/Pichers/CardLastStmHostel.vue";
    import {mapState, mapGetters, mapActions, mapMutations} from "vuex"

    export default {
        name: 'HostelStatement',
        components: {
            CardPersPerf,
            CardHostelPlace,
            CurrPlaceHostel,
            CardStatusesAllowance,
            CardLastStmHostel
        },
        data: () => ({}),
        mounted() {
            this.GetUser();
            this.ShowStatement().then(() => {
                this.Fluorography()
            });
            this.LastActualStatement();
            this.GetPrivilege();
        },
        updated() {
        },
        computed: {
            ...mapState({
                user: state => state.mainHostel.user,
                hostels: state => state.placesInDormitories.hostels
            }),
            getYear() {
                let date = new Date()
                return date.getFullYear()
            }
        },
        methods: {
            ...mapMutations({
                setUser: 'mainHostel/setUser',
            }),
            ...mapActions({
                GetUser: 'mainHostel/GetUser',
                ShowStatement: 'interactionStatement/ShowStatement',
                GetPrivilege: 'mainHostel/GetPrivilege',
                Fluorography: 'mainHostel/Fluorography',
                LastActualStatement: 'interactionStatement/LastActualStatement',
            }),
        }
    }
</script>


<style scoped>
  /deep/ .v-application--wrap {
    min-height: 1vh !important;
  }
</style>